import { useEffect } from 'react';
import { useSearchParams } from 'react-router-dom';
import blckslogo from '../assets/icons/BLCKS_LOGO_NEW.svg';
import circlecheckdarkgrey from '../assets/icons/circle-check_darkgrey_2.svg';

export default function ThankYou() {
  const [searchParams] = useSearchParams();
  const subscribed = searchParams.get('subscribed');

  // Hide navigation
  useEffect(() => {
    const nav = document.querySelector('nav');
    if (nav) nav.style.display = 'none';
    
    // Redirect to home if not coming from a subscription confirmation
    if (!subscribed) {
      window.location.href = '/';
    }

    // Cleanup function to restore navigation when component unmounts
    return () => {
      if (nav) nav.style.display = '';
    };
  }, [subscribed]);

  if (!subscribed) {
    return null; // or a loading spinner
  }

  return (
    <div className="min-h-screen bg-[#000000] flex flex-col items-center justify-center p-4">
      <div className="bg-[#0a0a0a] p-8 rounded-lg border border-[#1e1e1e] max-w-md w-full text-center">
        {/* Logo */}
        <div className="mb-6">
          <div className="relative h-8 w-32 mx-auto mb-6">
            <img 
              src={blckslogo} 
              alt="BLCKS AI Logo" 
              className="h-full w-auto mx-auto"
            />
          </div>
          <div className="h-px w-96 bg-[#1e1e1e] mx-auto"></div>
        </div>
        
        <div className="mb-4">
          <div className="relative h-24 w-24 mx-auto mb-4">
            <img 
              src={circlecheckdarkgrey} 
              alt="BLCKS AI Logo" 
              className="h-full w-auto mx-auto"
            />
          </div>
        </div>
        
        <h1 className="text-2xl font-medium text-white mb-6 font-sans">E-Mail bestätigt!</h1>
        <p className="text-[#A0A0A0] mb-8 font-sans text-sm">
          Vielen Dank, Ihre E-Mail-Adresse wurde erfolgreich bestätigt.
        </p>

        {/* What's Next Section */}
        <div className="bg-[#1a1a1a] p-6 rounded-lg mb-8 text-left">
          <p className="text-sm text-[#ffffff] mb-4 font-sans">Wie geht es weiter?</p>
          <ul className="text-sm text-[#A0A0A0] space-y-3 font-sans">
            <li className="flex items-start">
              <span className="text-[#A0A0A0] mr-3 font-mono">1.</span>
              <span>Unser Team prüft Ihre Angaben</span>
            </li>
            <li className="flex items-start">
              <span className="text-[#A0A0A0] mr-3 font-mono">2.</span>
              <span>Wir bereiten eine erste Kostenschätzung vor</span>
            </li>
            <li className="flex items-start">
              <span className="text-[#A0A0A0] mr-3 font-mono">3.</span>
              <span>Sie erhalten Ihre persönliche Kostenschätzung sowie weitere Schritte per E-Mail</span>
            </li>
          </ul>
        </div>
        
        <a 
          href="/" 
          className="inline-block bg-white text-[#070709] px-6 py-3 rounded-md font-medium hover:bg-gray-200 transition-colors font-sans"
        >
          Zurück zur Startseite
        </a>

        {/* Footer */}
        <div className="mt-8 pt-6 border-t border-[#1e1e1e] text-center">
          <p className="text-xs text-[#A0A0A0] mb-2 font-sans">Haben Sie weitere Fragen?</p>
          <a 
            href="mailto:hello@blcks.at" 
            className="text-sm text-white hover:underline font-sans"
          >
            hello@blcks.at
          </a>
          <p className="text-xs text-[#A0A0A0] mt-4 font-sans">
            © 2025 BLCKS. Alle Rechte vorbehalten.
          </p>
        </div>
      </div>
    </div>
  );
}
